export default __webpack_public_path__ + "static/media/12.cf2778e8.webp";